<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="overflowBtn"
        elevation="6"
        :color="partnerColor.primary"
        fab
        fixed
        bottom
        right
        v-bind="attrs"
        v-on="on"
        ><v-icon color="white"> mdi-plus </v-icon>
      </v-btn>
      <v-btn
        class="d-none d-sm-block ml-2"
        dense
        small
        depressed
        :color="partnerColor.primaryDarken_2"
        dark
        v-bind="attrs"
        v-on="on"
      >
        {{ $t("components.thg.ThgChargingStationForm.dialogBtn") }}
      </v-btn>
    </template>

    <v-card flat>
      <v-card-title :style="partnerColor.gradientStyle">
        <span :style="`color:white`">{{ $t("components.thg.ThgChargingStationForm.title") }}</span>
        <v-spacer />
        <v-btn :color="partnerColor.primaryDarken_3" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <thg-charging-station-form @save="save"></thg-charging-station-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { PartnerColor } from "@/lib/partnerColor";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";
import { ChargingStationModule } from "@/store/modules/charging-station.store";
import { ChargingStationUiDto } from "@/store/models/thg/create-charging-station";
import { HttpException } from "@/lib/exceptions/http";
import ThgChargingStationForm from "@/components/thg/ThgChargingStationForm.vue";

@Component({
  components: { ThgChargingStationForm }
})
export default class ThgChargingStationFormDialog extends DarkModeHighlightMixin {
  @Prop({ default: false })
  overflowBtn!: boolean;

  dialog = false;
  loading = false;

  async save(item: ChargingStationUiDto) {
    this.$log.debug(item);
    try {
      this.loading = true;
      await ChargingStationModule.createChargingStation(item.toCreateMyChargingStation());

      if (ChargingStationModule.activeChargingStation) {
        this.$router.push({
          name: "ThgChargingStationDetail",
          params: { chargingStationId: ChargingStationModule.activeChargingStation.id }
        });
      } else {
        this.$router.push({ name: "ThgChargingStationOverview" });
      }
    } catch (error) {
      this.$log.error(error);
      if (error instanceof HttpException) {
        this.$toast.error(error.message);
      }
    } finally {
      this.loading = false;
    }
  }

  openDialog() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  partnerColor = new PartnerColor();
}
</script>
